export const billingEndpoints = (builder) => ({

    billPackagePay: builder.query({
        query: ({ productId, token, paymentPageToken }) => ({
            url: "",
            params: {
                method_name: "bill_package_pay",
                product_id: String(productId),
                get_bill_only: "1",
                invoice_source: "UPP",
                user_token: token ?? "",
                payment_page_token: paymentPageToken ?? "",
            },
        }),
        transformResponse: (resp) => resp ?? {},
    }),

    billCheckout: builder.mutation({
        query: ({ productId, token, paymentPageToken, currency = "USD" }) => ({
            url: "",
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
            body: new URLSearchParams({
                method_name: "bill_checkout",
                product_id: String(productId),
                user_token: token ?? "",
                payment_page_token: paymentPageToken ?? "",
                currency,
                extra_package_only: "1",
                ui_mode: "embedded",
            }).toString(),
        }),
        transformResponse: (resp) => resp ?? {},
    }),
});
